import { makeStyles } from "tss-react/mui";
const useStyles = makeStyles()((theme, { maxWidth })=>({
        button: {
            display: 'flex',
            alignItems: 'center',
            boxSizing: 'border-box',
            height: 32,
            padding: `${theme.px(6)}px ${theme.tokens.spacing['12']}px`,
            borderRadius: theme.tokens.radius.m,
            border: `${theme.tokens.border.s}px solid ${theme.tokens.colors.accent.text.blue}`,
            color: `${theme.tokens.colors.original.brand.primary}`,
            backgroundColor: `${theme.tokens.colors.original.brand.secondary}`,
            gap: theme.tokens.spacing['8'],
            cursor: 'pointer'
        },
        withBorder: {
            border: `${theme.tokens.border.s}px solid ${theme.tokens.colors.stroke.primary}`,
            borderRadius: theme.tokens.radius.m
        },
        chip: {
            backgroundColor: theme.tokens.colors.bg.greyscale.primary,
            color: theme.tokens.colors.text.light.primary
        },
        chipDisabled: {
            backgroundColor: theme.tokens.colors.bg.greyscale.secondary,
            color: theme.tokens.colors.text.light.tertirary
        },
        chipError: {
            backgroundColor: theme.palette.error.light,
            color: theme.palette.secondary.main,
            '&:active, &:focus': {
                backgroundColor: theme.palette.error.light
            }
        },
        iconError: {
            color: theme.palette.secondary.main,
            '&:hover': {
                color: theme.palette.error.dark
            }
        },
        chipInput: {
            maxWidth: maxWidth ? maxWidth : 'unset'
        }
    }));
export { useStyles };
